import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext({});

export const ThemeProvider = ({ children }) => {
  // Siempre modo oscuro - sin opción de cambiar
  const isDark = true;

  // Establecer tema oscuro al iniciar
  useEffect(() => {
    localStorage.setItem('kompa-theme', 'dark');
    document.documentElement.setAttribute('data-theme', 'dark');
  }, []);

  const value = {
    isDark: true,
    isLight: false,
    theme: 'dark'
  };

  return (
    <ThemeContext.Provider value={value}>
      <div className="theme-dark">
        {children}
      </div>
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme debe ser usado dentro de un ThemeProvider');
  }
  return context;
};

export default ThemeContext;
